const countries = {
  Afghanistan: {
    name: 'Afghanistan',
    id: 'afghanistan',
    continent: 'Asia',
    shapeId: 'MEzedNnNVw',
  },
  Albania: {
    name: 'Albania',
    id: 'albania',
    continent: 'Europe',
    shapeId: '8rTBsf4ObQ',
  },
  Algeria: {
    name: 'Algeria',
    id: 'algeria',
    continent: 'Africa',
    shapeId: '8XKDe93BnC',
  },
  Andorra: {
    name: 'Andorra',
    id: 'andorra',
    continent: 'Europe',
    shapeId: 'sv7fjDVISU',
  },
  Angola: {
    name: 'Angola',
    id: 'angola',
    continent: 'Africa',
    shapeId: 'khAszEtDXl',
  },
  'Antigua and Barbuda': {
    name: 'Antigua and Barbuda',
    id: 'antigua_and_barbuda',
    continent: 'North America',
    shapeId: 'I8RkNYNHa4',
  },
  Argentina: {
    name: 'Argentina',
    id: 'argentina',
    continent: 'South America',
    shapeId: 'emj7gm2L4O',
  },
  Armenia: {
    name: 'Armenia',
    id: 'armenia',
    continent: 'Asia',
    shapeId: 'hVs5HyPvID',
  },
  Australia: {
    name: 'Australia',
    id: 'australia',
    continent: 'Oceania',
    shapeId: '8lauBzPLI5',
  },
  Austria: {
    name: 'Austria',
    id: 'austria',
    continent: 'Europe',
    shapeId: 'sbCG0KlS9w',
  },
  Azerbaijan: {
    name: 'Azerbaijan',
    id: 'azerbaijan',
    continent: 'Asia',
    shapeId: 'mDMzJJXtB2',
  },
  Bahamas: {
    name: 'Bahamas',
    id: 'bahamas',
    continent: 'North America',
    shapeId: '5xyA61UG1h',
  },
  Bahrain: {
    name: 'Bahrain',
    id: 'bahrain',
    continent: 'Asia',
    shapeId: 'gXKD3sCcJI',
  },
  Bangladesh: {
    name: 'Bangladesh',
    id: 'bangladesh',
    continent: 'Asia',
    shapeId: 'AWnxgoUzw0',
  },
  Barbados: {
    name: 'Barbados',
    id: 'barbados',
    continent: 'North America',
    shapeId: '27DB6uofpp',
  },
  Belarus: {
    name: 'Belarus',
    id: 'belarus',
    continent: 'Europe',
    shapeId: '5oTW0cNpxA',
  },
  Belgium: {
    name: 'Belgium',
    id: 'belgium',
    continent: 'Europe',
    shapeId: 'TySeDEiFtc',
  },
  Belize: {
    name: 'Belize',
    id: 'belize',
    continent: 'North America',
    shapeId: 'v9SGqANrU2',
  },
  Benin: {
    name: 'Benin',
    id: 'benin',
    continent: 'Africa',
    shapeId: 'zVrvUTYEeC',
  },
  Bhutan: {
    name: 'Bhutan',
    id: 'bhutan',
    continent: 'Asia',
    shapeId: 'ZvhrzA2APU',
  },
  Bolivia: {
    name: 'Bolivia',
    id: 'bolivia',
    continent: 'South America',
    shapeId: 'PdgGA5Y5Tt',
  },
  Bosnia: {
    name: 'Bosnia and Herzegovina',
    id: 'bosnia_and_herzegovina',
    continent: 'Europe',
    shapeId: 'OWstcXnnAs',
  },
  Botswana: {
    name: 'Botswana',
    id: 'botswana',
    continent: 'Africa',
    shapeId: '9l8d95idZG',
  },
  Brazil: {
    name: 'Brazil',
    id: 'brazil',
    continent: 'South America',
    shapeId: 'qq2ryXaIYG',
  },
  Brunei: {
    name: 'Brunei',
    id: 'brunei',
    continent: 'Asia',
    shapeId: 'W1DBYJ0DT4',
  },
  Bulgaria: {
    name: 'Bulgaria',
    id: 'bulgaria',
    continent: 'Europe',
    shapeId: 'LHOE9MSsmI',
  },
  'Burkina Faso': {
    name: 'Burkina Faso',
    id: 'burkina_faso',
    continent: 'Africa',
    shapeId: 'buIC80yx3R',
  },
  Burundi: {
    name: 'Burundi',
    id: 'burundi',
    continent: 'Africa',
    shapeId: 'qEgnSc4sip',
  },
  'Cabo Verde': {
    name: 'Cabo Verde',
    id: 'cabo_verde',
    continent: 'Africa',
    shapeId: 'LrFc6CEfje',
  },
  Cambodia: {
    name: 'Cambodia',
    id: 'cambodia',
    continent: 'Asia',
    shapeId: 'EpBnGVkBLF',
  },
  Cameroon: {
    name: 'Cameroon',
    id: 'cameroon',
    continent: 'Africa',
    shapeId: 'pUFZ2RIIvG',
  },
  Canada: {
    name: 'Canada',
    id: 'canada',
    continent: 'North America',
    shapeId: 'mTtBWeeHCo',
  },
  'Central African Republic': {
    name: 'Central African Republic',
    id: 'central_african_republic',
    continent: 'Africa',
    shapeId: 'CAFBhOmYoF',
  },
  Chad: {
    name: 'Chad',
    id: 'chad',
    continent: 'Africa',
    shapeId: '8lQ5LYAawJ',
  },
  Chile: {
    name: 'Chile',
    id: 'chile',
    continent: 'South America',
    shapeId: 'dnDRHIFqGe',
  },
  China: {
    name: 'China',
    id: 'china',
    continent: 'Asia',
    shapeId: 'jPsWdF78Gn',
  },
  Colombia: {
    name: 'Colombia',
    id: 'colombia',
    continent: 'South America',
    shapeId: 'R3I0XpBMHj',
  },
  Comoros: {
    name: 'Comoros',
    id: 'comoros',
    continent: 'Africa',
    shapeId: 'SJvwuMEme7',
  },
  Congo: {
    name: 'Congo (Brazzaville)',
    id: 'congo_(brazzaville)',
    continent: 'Africa',
    shapeId: '5jipXp430E',
  },
  'Costa Rica': {
    name: 'Costa Rica',
    id: 'costa_rica',
    continent: 'North America',
    shapeId: 'CcOW7twmeX',
  },
  Croatia: {
    name: 'Croatia',
    id: 'croatia',
    continent: 'Europe',
    shapeId: 'uj5JYO5BE3',
  },
  Cuba: {
    name: 'Cuba',
    id: 'cuba',
    continent: 'North America',
    shapeId: 'YNRVNxzcFx',
  },
  Cyprus: {
    name: 'Cyprus',
    id: 'cyprus',
    continent: 'Europe',
    shapeId: '1KRscl4VTZ',
  },
  Czechia: {
    name: 'Czechia',
    id: 'czechia',
    continent: 'Europe',
    shapeId: 'FIdcKBVyI3',
  },
  "Côte d'Ivoire": {
    name: "Côte d'Ivoire",
    id: 'cote_divoire',
    continent: 'Africa',
    shapeId: 'egoIFgkxC3',
  },
  DRC: {
    name: 'Congo (Kinshasa)',
    id: 'congo_(kinshasa)',
    continent: 'Africa',
    shapeId: '7UlxnC5LyT',
  },
  Denmark: {
    name: 'Denmark',
    id: 'denmark',
    continent: 'Europe',
    shapeId: '3SYcv5XaFE',
  },
  Djibouti: {
    name: 'Djibouti',
    id: 'djibouti',
    continent: 'Africa',
    shapeId: 'DKDsqKRrNW',
  },
  Dominica: {
    name: 'Dominica',
    id: 'dominica',
    continent: 'North America',
    shapeId: 'K9EoQTanO6',
  },
  'Dominican Republic': {
    name: 'Dominican Republic',
    id: 'dominican_republic',
    continent: 'North America',
    shapeId: 'BkDVxFnLbN',
  },
  Ecuador: {
    name: 'Ecuador',
    id: 'ecuador',
    continent: 'South America',
    shapeId: 'w42L24Frj9',
  },
  Egypt: {
    name: 'Egypt',
    id: 'egypt',
    continent: 'Africa',
    shapeId: 'hFkwjKITta',
  },
  'El Salvador': {
    name: 'El Salvador',
    id: 'el_salvador',
    continent: 'North America',
    shapeId: 'neXLLQcOcE',
  },
  'Equatorial Guinea': {
    name: 'Equatorial Guinea',
    id: 'equatorial_guinea',
    continent: 'Africa',
    shapeId: 'hzdCZRHhIY',
  },
  Eritrea: {
    name: 'Eritrea',
    id: 'eritrea',
    continent: 'Africa',
    shapeId: 'rVI3whtxQX',
  },
  Estonia: {
    name: 'Estonia',
    id: 'estonia',
    continent: 'Europe',
    shapeId: 'kGAoZ5pH7T',
  },
  Ethiopia: {
    name: 'Ethiopia',
    id: 'ethiopia',
    continent: 'Africa',
    shapeId: 'RG4CMN42m1',
  },
  Fiji: {
    name: 'Fiji',
    id: 'fiji',
    continent: 'Oceania',
    shapeId: '0iYnsd3adu',
  },
  Finland: {
    name: 'Finland',
    id: 'finland',
    continent: 'Europe',
    shapeId: 'nfHDWPtgDF',
  },
  France: {
    name: 'France',
    id: 'france',
    continent: 'Europe',
    shapeId: 'vBQFvgbzPX',
  },
  Gabon: {
    name: 'Gabon',
    id: 'gabon',
    continent: 'Africa',
    shapeId: '2aC5hV2kfd',
  },
  Gambia: {
    name: 'Gambia',
    id: 'gambia',
    continent: 'Africa',
    shapeId: 'DGGLf2Q1tS',
  },
  Georgia: {
    name: 'Georgia',
    id: 'georgia',
    continent: 'Asia',
    shapeId: 'J7QoCukbse',
  },
  Germany: {
    name: 'Germany',
    id: 'germany',
    continent: 'Europe',
    shapeId: 'cXVjaWqsnY',
  },
  Ghana: {
    name: 'Ghana',
    id: 'ghana',
    continent: 'Africa',
    shapeId: 'vCIN9WyEHn',
  },
  Greece: {
    name: 'Greece',
    id: 'greece',
    continent: 'Europe',
    shapeId: 'zuCmaUX1g9',
  },
  Grenada: {
    name: 'Grenada',
    id: 'grenada',
    continent: 'North America',
    shapeId: '8DHNNAHDXI',
  },
  Guatemala: {
    name: 'Guatemala',
    id: 'guatemala',
    continent: 'North America',
    shapeId: 'Rkb0Ji6GtG',
  },
  Guinea: {
    name: 'Guinea',
    id: 'guinea',
    continent: 'Africa',
    shapeId: 'l2E7bFn2O6',
  },
  'Guinea-Bissau': {
    name: 'Guinea-Bissau',
    id: 'guinea-bissau',
    continent: 'Africa',
    shapeId: 'HhLTUnF1fz',
  },
  Guyana: {
    name: 'Guyana',
    id: 'guyana',
    continent: 'South America',
    shapeId: 'uyLj6RP9AZ',
  },
  Haiti: {
    name: 'Haiti',
    id: 'haiti',
    continent: 'North America',
    shapeId: 'QLFfURjWpu',
  },
  'Holy See (Vatican City State)': {
    name: 'Holy See (Vatican City State)',
    id: 'holy_see',
    continent: 'Europe',
  },
  Honduras: {
    name: 'Honduras',
    id: 'honduras',
    continent: 'North America',
    shapeId: 'pM1H87l6Bm',
  },
  Hungary: {
    name: 'Hungary',
    id: 'hungary',
    continent: 'Europe',
    shapeId: 'f5WB3Ij653',
  },
  Iceland: {
    name: 'Iceland',
    id: 'iceland',
    continent: 'Europe',
    shapeId: '5VTtzmVSWN',
  },
  India: {
    name: 'India',
    id: 'india',
    continent: 'Asia',
    shapeId: 'DlHQBjd2Ke',
  },
  Indonesia: {
    name: 'Indonesia',
    id: 'indonesia',
    continent: 'Asia',
    shapeId: 'pOykqMaxZB',
  },
  Iran: {
    name: 'Iran',
    id: 'iran',
    continent: 'Asia',
    shapeId: 'wv4OCjRaNi',
  },
  Iraq: {
    name: 'Iraq',
    id: 'iraq',
    continent: 'Asia',
    shapeId: 'nvhpnKO5rE',
  },
  Ireland: {
    name: 'Ireland',
    id: 'ireland',
    continent: 'Europe',
    shapeId: 'FSUOeNw5vK',
  },
  Israel: {
    name: 'Israel',
    id: 'israel',
    continent: 'Asia',
    shapeId: '4lBFb6Wpq5',
  },
  Italy: {
    name: 'Italy',
    id: 'italy',
    continent: 'Europe',
    shapeId: 'hOu7Is3jvO',
  },
  Jamaica: {
    name: 'Jamaica',
    id: 'jamaica',
    continent: 'North America',
    shapeId: 'iRCCJGZ3RJ',
  },
  Japan: {
    name: 'Japan',
    id: 'japan',
    continent: 'Asia',
    shapeId: 'UN9yBtQstI',
  },
  Jordan: {
    name: 'Jordan',
    id: 'jordan',
    continent: 'Asia',
    shapeId: 'AVGAFwTSFb',
  },
  Kazakhstan: {
    name: 'Kazakhstan',
    id: 'kazakhstan',
    continent: 'Asia',
    shapeId: 'nRlkwMtWiB',
  },
  Kenya: {
    name: 'Kenya',
    id: 'kenya',
    continent: 'Africa',
    shapeId: 'hWGVevpYaK',
  },
  Kiribati: {
    name: 'Kiribati',
    id: 'kiribati',
    continent: 'Oceania',
    shapeId: 'qCcuxOqgkB',
  },
  Kuwait: {
    name: 'Kuwait',
    id: 'kuwait',
    continent: 'Asia',
    shapeId: 'qlkgJorlNV',
  },
  Kyrgyzstan: {
    name: 'Kyrgyzstan',
    id: 'kyrgyzstan',
    continent: 'Asia',
    shapeId: 'KoZCNHDS5X',
  },
  "Lao People's Democratic Republic": {
    name: 'Laos',
    id: 'laos',
    continent: 'Asia',
    shapeId: 'eaNpdUY6IC',
  },
  Latvia: {
    name: 'Latvia',
    id: 'latvia',
    continent: 'Europe',
    shapeId: 'SRLc1TCwHn',
  },
  Lebanon: {
    name: 'Lebanon',
    id: 'lebanon',
    continent: 'Asia',
    shapeId: 'P2wZxWNxtr',
  },
  Lesotho: {
    name: 'Lesotho',
    id: 'lesotho',
    continent: 'Africa',
    shapeId: 'fl5yo1HfMR',
  },
  Liberia: {
    name: 'Liberia',
    id: 'liberia',
    continent: 'Africa',
    shapeId: 'ZoFyPeNM5E',
  },
  'Libyan Arab Jamahiriya': {
    name: 'Libya',
    id: 'libya',
    continent: 'Africa',
    shapeId: 'FgwdDPUXmJ',
  },
  Liechtenstein: {
    name: 'Liechtenstein',
    id: 'liechtenstein',
    continent: 'Europe',
    shapeId: 'f83FzMh6Ty',
  },
  Lithuania: {
    name: 'Lithuania',
    id: 'lithuania',
    continent: 'Europe',
    shapeId: '9kbcTFZyKo',
  },
  Luxembourg: {
    name: 'Luxembourg',
    id: 'luxembourg',
    continent: 'Europe',
    shapeId: '5LNFOuO2Wh',
  },
  Macedonia: {
    name: 'North Macedonia',
    id: 'north_macedonia',
    continent: 'Europe',
    shapeId: 'dAH4X1RHQb',
  },
  Madagascar: {
    name: 'Madagascar',
    id: 'madagascar',
    continent: 'Africa',
    shapeId: '09fXl7u3FD',
  },
  Malawi: {
    name: 'Malawi',
    id: 'malawi',
    continent: 'Africa',
    shapeId: 'clpCIxZu1P',
  },
  Malaysia: {
    name: 'Malaysia',
    id: 'malaysia',
    continent: 'Asia',
    shapeId: 'SHOmq2VQlZ',
  },
  Maldives: {
    name: 'Maldives',
    id: 'maldives',
    continent: 'Asia',
    shapeId: 'ovfuQeRszZ',
  },
  Mali: {
    name: 'Mali',
    id: 'mali',
    continent: 'Africa',
    shapeId: 'jreQzrjZx6',
  },
  Malta: {
    name: 'Malta',
    id: 'malta',
    continent: 'Europe',
    shapeId: 'HEXUplP1Se',
  },
  Mauritania: {
    name: 'Mauritania',
    id: 'mauritania',
    continent: 'Africa',
    shapeId: '1hYnFHML5d',
  },
  Mauritius: {
    name: 'Mauritius',
    id: 'mauritius',
    continent: 'Africa',
    shapeId: 'cxnFBlqeWx',
  },
  Mexico: {
    name: 'Mexico',
    id: 'mexico',
    continent: 'North America',
    shapeId: 'jbrIeE76hr',
  },
  Micronesia: {
    name: 'Micronesia',
    id: 'micronesia',
    continent: 'Oceania',
    shapeId: 'Y3YvNEgaqp',
  },
  Moldova: {
    name: 'Moldova',
    id: 'moldova',
    continent: 'Europe',
    shapeId: 'bmYANF81hv',
  },
  Monaco: {
    name: 'Monaco',
    id: 'monaco',
    continent: 'Europe',
    shapeId: 'nE8gX0MFSZ',
  },
  Mongolia: {
    name: 'Mongolia',
    id: 'mongolia',
    continent: 'Asia',
    shapeId: '76H3yHIo7U',
  },
  Montenegro: {
    name: 'Montenegro',
    id: 'montenegro',
    continent: 'Europe',
    shapeId: 'wY0pApCtUt',
  },
  Morocco: {
    name: 'Morocco',
    id: 'morocco',
    continent: 'Africa',
    shapeId: 'Smz1hTRSIU',
  },
  Mozambique: {
    name: 'Mozambique',
    id: 'mozambique',
    continent: 'Africa',
    shapeId: '9CVfAKT2WO',
  },
  Namibia: {
    name: 'Namibia',
    id: 'namibia',
    continent: 'Africa',
    shapeId: 'cJ8QXx4aDG',
  },
  Nepal: {
    name: 'Nepal',
    id: 'nepal',
    continent: 'Asia',
    shapeId: 'uq5oiRuEKm',
  },
  Netherlands: {
    name: 'Netherlands',
    id: 'netherlands',
    continent: 'Europe',
    shapeId: '9FyUSGZNnf',
  },
  'New Zealand': {
    name: 'New Zealand',
    id: 'new_zealand',
    continent: 'Oceania',
    shapeId: '2vGNu7Yn7D',
  },
  Nicaragua: {
    name: 'Nicaragua',
    id: 'nicaragua',
    continent: 'North America',
    shapeId: 'sCGe1vsv7x',
  },
  Niger: {
    name: 'Niger',
    id: 'niger',
    continent: 'Africa',
    shapeId: 'lpk34LaX1T',
  },
  Nigeria: {
    name: 'Nigeria',
    id: 'nigeria',
    continent: 'Africa',
    shapeId: 'oqts6mjw76',
  },
  Norway: {
    name: 'Norway',
    id: 'norway',
    continent: 'Europe',
    shapeId: 'T6MXJLAUjG',
  },
  Oman: {
    name: 'Oman',
    id: 'oman',
    continent: 'Asia',
    shapeId: 'ta4EmTNWmu',
  },
  Pakistan: {
    name: 'Pakistan',
    id: 'pakistan',
    continent: 'Asia',
    shapeId: 'YE4pRFqDqA',
  },
  Panama: {
    name: 'Panama',
    id: 'panama',
    continent: 'North America',
    shapeId: 'fjNf3u1Mx1',
  },
  'Papua New Guinea': {
    name: 'Papua New Guinea',
    id: 'papua_new_guinea',
    continent: 'Oceania',
    shapeId: 'uonlBdxrxQ',
  },
  Paraguay: {
    name: 'Paraguay',
    id: 'paraguay',
    continent: 'South America',
    shapeId: '4GJnHdhGyv',
  },
  Peru: {
    name: 'Peru',
    id: 'peru',
    continent: 'South America',
    shapeId: '8IhgzPlSIn',
  },
  Philippines: {
    name: 'Philippines',
    id: 'philippines',
    continent: 'Asia',
    shapeId: 'pmnzGTREty',
  },
  Poland: {
    name: 'Poland',
    id: 'poland',
    continent: 'Europe',
    shapeId: 'bejQecXKxm',
  },
  Portugal: {
    name: 'Portugal',
    id: 'portugal',
    continent: 'Europe',
    shapeId: 'EZzqrmo1am',
  },
  Qatar: {
    name: 'Qatar',
    id: 'qatar',
    continent: 'Asia',
    shapeId: 'fadJTpiTZO',
  },
  Romania: {
    name: 'Romania',
    id: 'romania',
    continent: 'Europe',
    shapeId: '5QOfVVtfWk',
  },
  Russia: {
    name: 'Russia',
    id: 'russia',
    continent: 'Europe',
    shapeId: 'vg1c2CxgQ3',
  },
  Rwanda: {
    name: 'Rwanda',
    id: 'rwanda',
    continent: 'Africa',
    shapeId: 'vtGcP4T5wj',
  },
  'S. Korea': {
    name: 'Korea, South',
    id: 'korea,_south',
    continent: 'Asia',
    shapeId: 'H27W1K2Jx0',
  },
  'Saint Kitts and Nevis': {
    name: 'Saint Kitts and Nevis',
    id: 'saint_kitts_and_nevis',
    continent: 'North America',
    shapeId: 'wHnODFxZFO',
  },
  'Saint Lucia': {
    name: 'Saint Lucia',
    id: 'saint_lucia',
    continent: 'North America',
    shapeId: 'GOaMR5GKXm',
  },
  'Saint Vincent and the Grenadines': {
    name: 'Saint Vincent and the Grenadines',
    id: 'saint_vincent_and_the_grenadines',
    continent: 'North America',
    shapeId: 'SaCgGB3Wn9',
  },
  Samoa: {
    name: 'Samoa',
    id: 'samoa',
    continent: 'Oceania',
    shapeId: 'FgCSmJ0kEH',
  },
  'San Marino': {
    name: 'San Marino',
    id: 'san_marino',
    continent: 'Europe',
    shapeId: '80T3vlLgy2',
  },
  'Sao Tome and Principe': {
    name: 'Sao Tome and Principe',
    id: 'sao_tome_and_principe',
    continent: 'Africa',
  },
  'Saudi Arabia': {
    name: 'Saudi Arabia',
    id: 'saudi_arabia',
    continent: 'Asia',
    shapeId: 'PqGe1JXHMY',
  },
  Senegal: {
    name: 'Senegal',
    id: 'senegal',
    continent: 'Africa',
    shapeId: 'loX389odU1',
  },
  Serbia: {
    name: 'Serbia',
    id: 'serbia',
    continent: 'Europe',
    shapeId: 'AqY4dkqJok',
  },
  Seychelles: {
    name: 'Seychelles',
    id: 'seychelles',
    continent: 'Africa',
    shapeId: 'vRMloHTZn5',
  },
  'Sierra Leone': {
    name: 'Sierra Leone',
    id: 'sierra_leone',
    continent: 'Africa',
    shapeId: 'xzEkRDMtUU',
  },
  Singapore: {
    name: 'Singapore',
    id: 'singapore',
    continent: 'Asia',
    shapeId: 'AnLxFNCcFS',
  },
  Slovakia: {
    name: 'Slovakia',
    id: 'slovakia',
    continent: 'Europe',
    shapeId: '2PuVugMMXs',
  },
  Slovenia: {
    name: 'Slovenia',
    id: 'slovenia',
    continent: 'Europe',
    shapeId: 'oQQC8mAbuz',
  },
  Somalia: {
    name: 'Somalia',
    id: 'somalia',
    continent: 'Africa',
    shapeId: '0ncikAUv2i',
  },
  'South Africa': {
    name: 'South Africa',
    id: 'south_africa',
    continent: 'Africa',
    shapeId: 'LQBwxAvUsE',
  },
  'South Sudan': {
    name: 'South Sudan',
    id: 'south_sudan',
    continent: 'Africa',
    shapeId: 'ICkEMQPTMM',
  },
  Spain: {
    name: 'Spain',
    id: 'spain',
    continent: 'Europe',
    shapeId: '5Vs8zprtNC',
  },
  'Sri Lanka': {
    name: 'Sri Lanka',
    id: 'sri_lanka',
    continent: 'Asia',
    shapeId: '9N0Bhm2Ge4',
  },
  Sudan: {
    name: 'Sudan',
    id: 'sudan',
    continent: 'Africa',
    shapeId: 'uPVdFzQ71M',
  },
  Suriname: {
    name: 'Suriname',
    id: 'suriname',
    continent: 'South America',
    shapeId: 'iNVlDu9rb9',
  },
  Swaziland: {
    name: 'Eswatini',
    id: 'eswatini',
    continent: 'Africa',
    shapeId: 'uVLeKcyCeh',
  },
  Sweden: {
    name: 'Sweden',
    id: 'sweden',
    continent: 'Europe',
    shapeId: '220UohZbeo',
  },
  Switzerland: {
    name: 'Switzerland',
    id: 'switzerland',
    continent: 'Europe',
    shapeId: 'c2ZdW21DZq',
  },
  'Syrian Arab Republic': {
    name: 'Syria',
    id: 'syria',
    continent: 'Asia',
    shapeId: 'aCjqJX3che',
  },
  Taiwan: {
    name: 'Taiwan',
    id: 'taiwan',
    continent: 'Asia',
    shapeId: 'UnNh8r7cvJ',
  },
  Tajikistan: {
    name: 'Tajikistan',
    id: 'tajikistan',
    continent: 'Asia',
    shapeId: 'temdDhXHMy',
  },
  Tanzania: {
    name: 'Tanzania',
    id: 'tanzania',
    continent: 'Africa',
    shapeId: 'UIOtsTw0oX',
  },
  Thailand: {
    name: 'Thailand',
    id: 'thailand',
    continent: 'Asia',
    shapeId: 'k2lukc4AyV',
  },
  'Timor-Leste': {
    name: 'Timor-Leste',
    id: 'timor-leste',
    continent: 'Asia',
  },
  Togo: {
    name: 'Togo',
    id: 'togo',
    continent: 'Africa',
    shapeId: 'LlF4qcKuXw',
  },
  'Trinidad and Tobago': {
    name: 'Trinidad and Tobago',
    id: 'trinidad_and_tobago',
    continent: 'North America',
    shapeId: 'CseuLCM1Du',
  },
  Tunisia: {
    name: 'Tunisia',
    id: 'tunisia',
    continent: 'Africa',
    shapeId: '6FCCfIIcf0',
  },
  Turkey: {
    name: 'Turkey',
    id: 'turkey',
    continent: 'Asia',
    shapeId: 'r1dBFhG3I7',
  },
  UAE: {
    name: 'United Arab Emirates',
    id: 'united_arab_emirates',
    continent: 'Asia',
    shapeId: 'VqASvLCk8S',
  },
  UK: {
    name: 'United Kingdom',
    id: 'united_kingdom',
    continent: 'Europe',
    shapeId: 'asMYxtQNZx',
  },
  Uganda: {
    name: 'Uganda',
    id: 'uganda',
    continent: 'Africa',
    shapeId: 'VrjHD4Le7A',
  },
  Ukraine: {
    name: 'Ukraine',
    id: 'ukraine',
    continent: 'Europe',
    shapeId: 'CzhIuuHOMH',
  },
  Uruguay: {
    name: 'Uruguay',
    id: 'uruguay',
    continent: 'South America',
    shapeId: 'R0GyWd9YXw',
  },
  USA: {
    name: 'USA',
    id: 'usa',
    continent: 'North America',
    shapeId: 'BXkZTl2omc',
  },
  Uzbekistan: {
    name: 'Uzbekistan',
    id: 'uzbekistan',
    continent: 'Asia',
    shapeId: 'E4wHs4HoxE',
  },
  Vanuatu: {
    name: 'Vanuatu',
    id: 'vanuatu',
    continent: 'Oceania',
    shapeId: 'z3FhnVKZEk',
  },
  Venezuela: {
    name: 'Venezuela',
    id: 'venezuela',
    continent: 'South America',
    shapeId: 'RJHFlkiRRU',
  },
  Vietnam: {
    name: 'Vietnam',
    id: 'vietnam',
    continent: 'Asia',
    shapeId: 'MFNxWtOZIm',
  },
  'Western Sahara': {
    name: 'Western Sahara',
    id: 'western_sahara',
    continent: 'Africa',
    shapeId: 'cRUrTJH6np',
  },
  Yemen: {
    name: 'Yemen',
    id: 'yemen',
    continent: 'Asia',
    shapeId: '9tt1nNL4xu',
  },
  Zambia: {
    name: 'Zambia',
    id: 'zambia',
    continent: 'Africa',
    shapeId: 'Hf8Po3Jb1p',
  },
  Zimbabwe: {
    name: 'Zimbabwe',
    id: 'zimbabwe',
    continent: 'Africa',
    shapeId: 'hvaqvemFp8',
  },
};

export default countries;
